if (! document.getElementById("mocha")) { document.write("<div id=\"mocha\"></div>"); }

require("!style-loader!css-loader!mocha/mocha.css");
require("!script-loader!mocha/mocha.js");



//////////////////
// WEBPACK FOOTER
// ./~/mocha-loader/web.js
// module id = 89
// module chunks = 3